import React, { useState } from 'react';
import { HomeTable, FiltersContainer } from '../../components/videos';

const Home = () => {
  const [searchRes, setSearchRes] = useState(null);
  const [loading, setLoading] = useState(false);

  return (
    <div className="min-h-[calc(100vh-75px)]">
      <div className="w-full px-4 py-4 sm:px-6 sm:py-6 space-y-4">
        <FiltersContainer
          searchRes={searchRes}
          setLoading={setLoading}
          setSearchRes={setSearchRes}
        />

        <div className="bg-slate-50 rounded-xl shadow-lg shadow-slate-300/50 border border-slate-200/60 overflow-hidden">
          <div className="p-4 sm:p-5">
            <div className="mb-4 flex items-baseline justify-between border-b border-slate-200 pb-3">
              <h2 className="text-lg font-semibold text-slate-800">
                {searchRes ? 'Search Results' : 'Videos History'}
              </h2>
              {searchRes && (
                <span className="text-xs tracking-wide text-slate-400">
                  {searchRes.length} match{searchRes.length === 1 ? '' : 'es'}
                </span>
              )}
            </div>
            <HomeTable
              searchRes={searchRes}
              loading={loading}
              setLoading={setLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
